import angular from 'angular';

angular.module('cloudX').directive('cxCountryTypeahead', [
  '$filter',
  '$rootScope',
  'dataCache',
  function($filter, $rootScope, dataCache) {
    return {
      restrict: 'E',
      replace: true,
      template:
        '<div class="dropdown" uib-dropdown ng-show="countries.length" is-open="ddwOpen">' +
        ' <div class="input-group">' +
        '     <span class="input-group-addon"><div ng-class="\'iti__flag iti__\' + value.toLowerCase()"></div></span>' +
        '     <input type="text" ng-model="selected" uib-typeahead="country as country.label for country in countries | filter:$viewValue | orderBy:[\'-common\',\'+label\'] | limitTo:limit " typeahead-min-length="0" typeahead-select-on-blur="selectOnBlur" typeahead-select-on-exact="selectOnExact" typeahead-on-select="onSelect($item)" ng-blur="onBlur()" ng-focus="ddwOpen=false" class="form-control" placeholder="{{placeholder}}" autocomplete="off" />' +
        '     <span class="input-group-btn">' +
        '         <button class="btn btn-default dropdown-toggle btn-font-14" uib-dropdown-toggle>' +
        '             <span class="caret"></span>' +
        '         </button>' +
        '     </span>' +
        ' </div>' +
        ' <ul class="dropdown-menu dropdown-menu-right" role="menu" style="max-height:200px;overflow-y:auto">' +
        '     <li ng-repeat="op in countries | filter:{common:true} | orderBy:[\'label\']" ng-class="{\'selected\':op===selected}">' +
        '         <a href ng-click="onSelect(op)"><div class="flag-box"><div ng-class="\'iti__flag iti__\' + op.id.toLowerCase()"></div></div><span class="country-name">{{op.label}}</span></a>' +
        '     </li>' +
        '     <li role="separator" class="divider"></li>' +
        '     <li ng-show="showAll" ng-repeat="op in countries | orderBy:[\'+label\']" ng-class="{\'selected\':op===selected}">' +
        '         <a href ng-click="onSelect(op)"><div class="flag-box"><div ng-class="\'iti__flag iti__\' + op.id.toLowerCase()"></div></div><span class="country-name">{{op.label}}</span></a>' +
        '     </li>' +
        '     <li ng-hide="showAll"><a href ng-click="showAll=true; $event.stopPropagation();"><span data-translate>Show all</span></a></li>' +
        ' </ul>' +
        '</div>',
      require: 'ngModel',
      link: function($scope, el, attrs, ngModel) {
        if (!ngModel) return;

        var options = dataCache.getArray('country');
        $scope.limit = $scope.$eval(attrs.limit) || 10;
        $scope.selectOnBlur = angular.isDefined(attrs.selectOnBlur)
          ? $scope.$eval(attrs.selectOnBlur) || attrs.selectOnBlur
          : true;
        $scope.selectOnExact = angular.isDefined(attrs.selectOnExact)
          ? $scope.$eval(attrs.selectOnExact) || attrs.selectOnExact
          : true;
        $scope.showAll = false;

        var findCountry = function(code) {
          if (code == null || $scope.countries.length === 0) return null;
          return $scope.countries.find(function(el) {
            return el.id === code;
          });
        };

        var mapOptions = function() {
          $scope.placeholder = $filter('translateList')(null, 'country');
          $scope.countries = options.map(function(c) {
            return {
              id: c.code,
              label: $filter('translateList')(c.code, 'country', c.name),
              common: c.isCommon,
            };
          });
          $scope.selected = findCountry($scope.value);
        };

        mapOptions();
        var deregistration = $rootScope.$on('$translateChangeSuccess', mapOptions);
        $scope.$on('$destroy', deregistration);

        $scope.onSelect = function(item) {
          $scope.selected = item;
          $scope.value = item.id;
          ngModel.$setViewValue(item.id);
        };
        $scope.onBlur = function() {
          if ($scope.selected != null && $scope.selected.id != null) return;
          $scope.value = null;
          $scope.selected = null;
          ngModel.$setViewValue(null);
        };

        ngModel.$render = function() {
          $scope.value = ngModel.$viewValue;
          $scope.selected = findCountry($scope.value);
        };
      },
    };
  },
]);
